
import { defineComponent, ref } from 'vue'
import UIkit from 'uikit'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import DropArea from '@/components/Shared/DropArea.vue'
import ErrorMessage from '@/components/Shared/Form/ErrorMessage.vue'

export default defineComponent({
  components: {
    DropArea,
    ErrorMessage
  },
  props: {
    modalId: { type: String, required: true }
  },
  emits: ['imageUploaded'],
  setup(props, { emit }) {
    const title = ref()
    const rules = {
      title: { required }
    }
    const v$ = useVuelidate(rules, { title })
    const filesUploadedHandler = () => {
      const modal = document.getElementById(props.modalId)
      if (!modal) return

      UIkit.modal(modal).hide()
      emit('imageUploaded')
    }
    const hiddenModalHandler = () => {
      title.value = null
      // @ts-ignore
      v$._value.$reset()
    }

    return {
      title,
      v$,
      filesUploadedHandler,
      hiddenModalHandler
    }
  }
})
